<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-5 col-xl-4 my-5">
        <div class="text-center">
          <!-- Preheading -->
          <h6 class="text-uppercase text-muted mb-4">404 error</h6>

          <!-- Heading -->
          <h1 class="display-4 mb-3">Estamos migrando nossos servidores no momento. 😭</h1>

          <!-- Subheading -->
          <p
            class="text-muted mb-4"
          >Retornaremos o mais rápido possivel, contamos com sua compreensão.</p>

          <!-- Button -->
          <!-- <a href="/" class="btn btn-lg btn-primary">Retorne a pagina principal!</a> -->
        </div>
      </div>
    </div>
    <!-- / .row -->
  </div>
  <!-- / .container -->
</template>

<script>
export default {

}
</script>

<style>
</style>